import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { ApplicationSettingsComponent } from './features/application-settings/application-settings.component';
import { BodyTypeDetailComponent } from './features/body-types/body-type-detail/body-type-detail.component';
import { BodyTypesComponent } from './features/body-types/body-types.component';
import { BrandDetailComponent } from './features/brands/brand-detail/brand-detail.component';
import { BrandsComponent } from './features/brands/brands.component';
import { CarClassDetailComponent } from './features/car-classes/car-class-detail/car-class-detail.component';
import { CarClassesComponent } from './features/car-classes/car-classes.component';
import { CountriesComponent } from './features/countries/countries.component';
import { CountryDetailComponent } from './features/countries/country-detail/country-detail.component';
import { DealershipDetailComponent } from './features/dealerships/dealership-detail/dealership-detail.component';
import { DealershipsComponent } from './features/dealerships/dealerships.component';
import { DetailDetailComponent } from './features/details/detail-detail/detail-detail.component';
import { DetailsComponent } from './features/details/details.component';
import {
    FirmwareRolloutDashboardComponent
} from './features/firmware-rollout-dashboard/firmware-rollout-dashboard.component';
import { RolloutDetailComponent } from './features/firmware-rollout-dashboard/rollout-detail/rollout-detail.component';
import { HomeComponent } from './features/home/home.component';
import { LanguageDetailComponent } from './features/languages/language-detail/language-detail.component';
import { LanguagesComponent } from './features/languages/languages.component';
import { ImprintComponent } from './features/legal/imprint/imprint.component';
import { PrivacyComponent } from './features/legal/privacy/privacy.component';
import { LoginComponent } from './features/login/login.component';
import { MailNotificationsComponent } from './features/mail-notifications/mail-notifications.component';
import {
    ManufacturerDetailComponent
} from './features/manufacturers/manufacturer-detail/manufacturer-detail.component';
import { ManufacturersComponent } from './features/manufacturers/manufacturers.component';
import { MediaComponent } from './features/media/media.component';
import { MyTasksComponent } from './features/my-tasks/my-tasks.component';
import {
    PhysicalSampleDetailComponent
} from './features/physical-samples/physical-sample-detail/physical-sample-detail.component';
import { PhysicalSamplesComponent } from './features/physical-samples/physical-samples.component';
import { PlayerComponent } from './features/player/player.component';
import { RetailerHomeComponent } from './features/retailer/retailer-home/retailer-home.component';
import {
    RetailerManageSamplesComponent
} from './features/retailer/retailer-manage-samples/retailer-manage-samples.component';
import { SelectDetailsComponent } from './features/retailer/select-details/select-details.component';
import { SelectVehicleModelComponent } from './features/retailer/select-vehicle-model/select-vehicle-model.component';
import { SampleFirmwareComponent } from './features/sample-firmware/sample-firmware.component';
import { SampleHardwareComponent } from './features/sample-hardware/sample-hardware.component';
import {
    SampleCategoryDetailComponent
} from './features/sample-types/sample-category-detail/sample-category-detail.component';
import { SampleTypeDetailComponent } from './features/sample-types/sample-type-detail/sample-type-detail.component';
import { SampleTypesComponent } from './features/sample-types/sample-types.component';
import { SampleDetailComponent } from './features/samples/sample-detail/sample-detail.component';
import { SamplesComponent } from './features/samples/samples.component';
import { StudioDetailComponent } from './features/studios/studio-detail/studio-detail.component';
import { StudiosComponent } from './features/studios/studios.component';
import {
    VehicleModelDetailComponent
} from './features/vehicle-models/vehicle-model-detail/vehicle-model-detail.component';
import { VehicleModelsComponent } from './features/vehicle-models/vehicle-models.component';
import { MainComponent } from './layouts/main/main.component';
import { RetailerComponent } from './layouts/retailer/retailer.component';

export const routes: Routes = [
    {
        path: '', component: MainComponent, children: [
            { path: '', component: HomeComponent, canActivate: [ AuthGuard ] },
            { path: 'samples', component: SamplesComponent, canActivate: [ AuthGuard ] },
            { path: 'samples/sample/:id', component: SampleDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'languages', component: LanguagesComponent, canActivate: [ AuthGuard ] },
            { path: 'languages/language/:id', component: LanguageDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'media', component: MediaComponent },
            { path: 'countries', component: CountriesComponent, canActivate: [ AuthGuard ] },
            { path: 'countries/country/:id', component: CountryDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'car-classes', component: CarClassesComponent, canActivate: [ AuthGuard ] },
            { path: 'car-classes/car-class/:id', component: CarClassDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'brands', component: BrandsComponent, canActivate: [ AuthGuard ] },
            { path: 'brands/brand/:id', component: BrandDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'body-types', component: BodyTypesComponent, canActivate: [ AuthGuard ] },
            { path: 'body-types/body-type/:id', component: BodyTypeDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'vehicle-models', component: VehicleModelsComponent, canActivate: [ AuthGuard ] },
            {
                path: 'vehicle-models/vehicle-model/:id',
                component: VehicleModelDetailComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'manufacturers', component: ManufacturersComponent, canActivate: [ AuthGuard ] },
            {
                path: 'manufacturers/manufacturer/:id',
                component: ManufacturerDetailComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'dealerships', component: DealershipsComponent, canActivate: [ AuthGuard ] },
            { path: 'dealerships/dealership/:id', component: DealershipDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'studios', component: StudiosComponent, canActivate: [ AuthGuard ] },
            { path: 'studios/studio/:id', component: StudioDetailComponent, canActivate: [ AuthGuard ] },
            {
                path: 'studios/studio/:id/firmware-rollout',
                component: FirmwareRolloutDashboardComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'firmware-rollouts', component: FirmwareRolloutDashboardComponent, canActivate: [ AuthGuard ] },
            {
                path: 'firmware-rollouts/rollout/:rolloutId',
                component: RolloutDetailComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'physical-samples', component: PhysicalSamplesComponent, canActivate: [ AuthGuard ] },
            {
                path: 'physical-samples/physical-sample/:id',
                component: PhysicalSampleDetailComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'sample-types', component: SampleTypesComponent, canActivate: [ AuthGuard ] },
            { path: 'sample-types/sample-type/:id', component: SampleTypeDetailComponent, canActivate: [ AuthGuard ] },
            {
                path: 'sample-types/sample-category/:id',
                component: SampleCategoryDetailComponent,
                canActivate: [ AuthGuard ]
            },
            { path: 'sample-hardware', component: SampleHardwareComponent, canActivate: [ AuthGuard ] },
            { path: 'sample-firmware', component: SampleFirmwareComponent, canActivate: [ AuthGuard ] },
            { path: 'settings', component: ApplicationSettingsComponent, canActivate: [ AuthGuard ] },
            { path: 'mail-notifications', component: MailNotificationsComponent, canActivate: [ AuthGuard ] },
            { path: 'tasks', component: MyTasksComponent, canActivate: [ AuthGuard ] },
            { path: 'details', component: DetailsComponent, canActivate: [ AuthGuard ] },
            { path: 'details/detail/:id', component: DetailDetailComponent, canActivate: [ AuthGuard ] },
            { path: 'legal/imprint', component: ImprintComponent },
            { path: 'legal/privacy', component: PrivacyComponent },
            { path: 'login', component: LoginComponent },
        ],
    },
    {
        path: 'retailer', component: RetailerComponent, canActivate: [ AuthGuard ], children: [
            {
                path: '', component: RetailerHomeComponent,
            },
            {
                path: 'manage-samples', component: RetailerManageSamplesComponent,
            },
            {
                path: 'select-vehicle-model', component: SelectVehicleModelComponent,
            },
            {
                path: 'select-details/:id', component: SelectDetailsComponent,
            }
        ]
    },
    { path: 'player', component: PlayerComponent },
    { path: '**', redirectTo: 'login' },
];
